import { createFileRoute, redirect } from '@tanstack/react-router'
import { LandedCostScreen } from '@/features/purchasing-landed-costs/landed-cost-screen'
import { hasGrant } from '@/lib/me'

/** Route shell for one landed cost. */
export const Route = createFileRoute('/_authenticated/purchasing/landed-costs/$landedCostId/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'landed_cost.view')) {
      throw redirect({ to: '/purchasing/landed-costs' })
    }
  },
  component: LandedCostRoute,
})

function LandedCostRoute() {
  const { landedCostId } = Route.useParams()

  return <LandedCostScreen landedCostId={landedCostId} />
}
